// @flow
import * as React from "react";
import { Trans } from "react-i18next";
import { Icon, Header, Button } from "semantic-ui-react";
import { Link } from "react-router-dom";

import DashboardRoute from "modules/Dashboard/misc/Routes";

import "./RegistrationSuccess.scss";

type Props = {
  t: typeof TFunction,
  showLoginMessage?: boolean,
};

let IframeRegistrationSuccessMessage = ({ t, showLoginMessage }: Props): React.Node => {
  if (showLoginMessage) {
    return (
      <>
        <div className="flexGrow">
          <Icon style={{ alignSelf: "center" }} name="check circle outline" color="green" size="big" />
          <h4 className="titleSmallMargin">
            <Trans i18nKey="auth:confirmationPage.title1">
              <br />
            </Trans>
          </h4>
          <p>{t("auth:confirmationPage.subtitle")}</p>
        </div>
        <div className="flexFixed">
          <Link target="_blank" to={DashboardRoute} style={{ alignSelf: "center" }}>
            <Button primary>
              {t("common:toDashboard")}
              <Icon name="arrow right" />
            </Button>
          </Link>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="flexGrow">
        <Header as="h5" data-cy={"registration_success"}>
          <Icon name={"check"} className="theme-color-primary" />
          <Header.Content>{t("auth:registration.onlySmallStep")}</Header.Content>
        </Header>
        <h4 className="titleSmallMargin">{t("auth:registration.emailSent")}</h4>
        <p>{t("auth:registration.missingEmail")}</p>
        <p>
          <Trans t={t} i18nKey="auth:registration.contactCustomerSupport">
            {/*prettier-ignore*/}
            <a href="mailto:service@remind.me" className={"RegistrationSuccessMessage green-mailTo"}> </a>
          </Trans>
        </p>
      </div>
      <div className="flexFixed">
        <Link target="_blank" to={DashboardRoute} style={{ alignSelf: "center" }}>
          <Button secondary>{t("auth:registration.toDashboardButton")}</Button>
        </Link>
      </div>
    </>
  );
};

export default IframeRegistrationSuccessMessage;
